import React from "react";

const NumberIcon = (props) => {
  const { default_color } = props;
  return (
    <svg viewBox="0 0 25 25" version="1.1" width="16" height="16" stroke="#955702" stroke-width="0.15"
 transform="matrix(1, 0, 0, 1, 0, 0)">
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="#CCCCCC"
        stroke-width="0.05"
      />

      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0165 17.6336H3.83636V16.4336H21.0165V17.6336Z"
          fill="#955702"
        />
        <path
          d="M7.09808 13.3967V7.50803H5.74066L3.83636 8.78244V10.091L5.65277 
  8.88498H5.74066V13.3967H3.84125V14.5539H8.89984V13.3967H7.09808Z"
          fill="#955702"
        />
        <path
          d="M9.81781 9.63205V9.66135H11.1069V9.62717C11.1069 8.95334 11.5756 8.49435
    12.2739 8.49435C12.9575 8.49435 13.4018 8.89474 13.4018 9.5051C13.4018 9.97873 
    13.1528 10.3498 12.1909 11.3117L9.89594 13.5822V14.5539H14.8618V13.3869H11.7807V13.299L13.1577 
    11.9856C14.3491 10.843 14.7543 10.1838 14.7543 9.41232C14.7543 8.19162 13.7729 7.36642 12.3178 
    7.36642C10.8383 7.36642 9.81781 8.28439 9.81781 9.63205Z"
          fill="#955702"
        />
        <path
          d="M17.6694 11.4631H18.5092C19.3198 11.4631 19.8422 11.8684 19.8422 12.4983C19.8422 
     13.1184 19.3295 13.5139 18.5239 13.5139C17.767 13.5139 17.2592 13.133 17.2104 12.5324H15.9262C15.9897 
     13.8508 17.0248 14.6955 18.5629 14.6955C20.1401 14.6955 21.2192 13.841 21.2192 12.591C21.2192 11.6584 
     20.6528 11.0334 19.7006 10.9211V10.8332C20.4721 10.677 20.9457 10.0666 20.9457 9.23654C20.9457 8.12326 
     19.9741 7.36642 18.5434 7.36642C17.0541 7.36642 16.1118 8.17697 16.0629 9.50021H17.2983C17.3422 8.8801 
     17.8061 8.48459 18.4995 8.48459C19.2075 8.48459 19.6567 8.85568 19.6567 9.44162C19.6567 10.0324 19.1977 
     10.4182 18.4946 10.4182H17.6694V11.4631Z"
          fill="#955702"
        />{" "}
      </g>
    </svg>
    // </div>
  );
};

export default NumberIcon;
